// src/components/energy-reset/NudgeBanner.tsx
type Props = {
  show: boolean;
  onAction: () => void;
  text?: string;
};

export default function NudgeBanner({ show, onAction, text }: Props) {
  if (!show) return null;
  return (
    <div className="mb-4 rounded-2xl border border-[#FF6F91]/20 bg-[#FF6F91]/10 p-3 flex items-center justify-between">
      <div className="text-sm">{text ?? "3 минуты — успеешь до обеда 😉"}</div>
      <button
        onClick={onAction}
        className="btn-primary ml-3 px-4 py-2 rounded-xl text-sm font-semibold"
      >
        Сделать сейчас
      </button>
    </div>
  );
}
